// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: process.env.NX_TASK_TARGET_CONFIGURATION === 'production' || process.env.NX_TASK_TARGET_CONFIGURATION === 'staging',
};
